import { useState } from 'react';
import MainLayout from '../components/MainLayout';
import { mainTable } from '../css/Common';
import InputText from '../ReusableComponents/InputText';
import ReportGridPage from '../components/ReportGridPage';
import { ComplaintsAndIssuesHeader } from '../components/HeaderAttribute';
//import { ComplaintsAndIssuesHeader, EnquirytobookingHeader } from '../components/HeaderAttribute';

const ComplaintsAndIssues = () => {
  const [formFields, setFormFields] = useState({
    fromDate: '',
    toDate: '',
  });

  const [errors, setErrors] = useState({
    fromDate: '',
    toDate: ''
  });

  const [showTable, setShowTable] = useState(false);
  const [BindEnquirytobookingData, setBindEnquirytobookingData] = useState([
    {
      sno: 1,
      complaintDate: "01-06-2025",
      guestName: "John Doe",
      villaType: "Deluxe",
      villaName: "Sunrise Villa",
      complaint: "Air conditioner not working",
      status: "Pending",
      resolveDate: "03-06-2025",
    },
    {
      sno: 2,
      complaintDate: "02-06-2025",
      guestName: "Jane Smith",
      villaType: "Standard",
      villaName: "Palm Retreat",
      complaint: "Leaky bathroom tap",
      status: "Resolved",
      resolveDate: "04-06-2025",
    },
    {
      sno: 3,
      complaintDate: "03-06-2025",
      guestName: "Robert Brown",
      villaType: "Luxury",
      villaName: "Ocean Breeze",
      complaint: "Wi-Fi not available",
      status: "In Progress",
      resolveDate: "",
    },
    {
      sno: 4,
      complaintDate: "04-06-2025",
      guestName: "Emily Davis",
      villaType: "Deluxe",
      villaName: "Mountain Escape",
      complaint: "Unclean towels",
      status: "Resolved",
      resolveDate: "06-06-2025",
    },
    {
      sno: 5,
      complaintDate: "05-06-2025",
      guestName: "Michael Scott",
      villaType: "Premium",
      villaName: "Lakeside Villa",
      complaint: "No hot water",
      status: "Pending",
      resolveDate: "",
    },
    {
      sno: 6,
      complaintDate: "06-06-2025",
      guestName: "Pam Beesly",
      villaType: "Standard",
      villaName: "Garden View",
      complaint: "TV not working",
      status: "Resolved",
      resolveDate: "07-06-2025",
    },
    {
      sno: 7,
      complaintDate: "07-06-2025",
      guestName: "Jim Halpert",
      villaType: "Luxury",
      villaName: "Forest Retreat",
      complaint: "Power outage",
      status: "Resolved",
      resolveDate: "08-06-2025",
    },
    {
      sno: 8,
      complaintDate: "08-06-2025",
      guestName: "Dwight Schrute",
      villaType: "Deluxe",
      villaName: "Sunset Villa",
      complaint: "No toiletries provided",
      status: "In Progress",
      resolveDate: "",
    },
    {
      sno: 9,
      complaintDate: "09-06-2025",
      guestName: "Angela Martin",
      villaType: "Standard",
      villaName: "Hillside Cottage",
      complaint: "Dirty bed sheets",
      status: "Pending",
      resolveDate: "",
    },
    {
      sno: 10,
      complaintDate: "10-06-2025",
      guestName: "Stanley Hudson",
      villaType: "Luxury",
      villaName: "Royal Villa",
      complaint: "No room service",
      status: "Resolved",
      resolveDate: "12-06-2025",
    },
  ]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = '';

    if (value.trim() === '') {
      const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
      error = `Enter ${formattedName}`;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));
  };

  const GoButton = () => {
    let hasError = false;
    const newErrors = { fromDate: '', toDate: '' };

    if (!formFields.fromDate.trim()) {
      newErrors.fromDate = 'Enter From Date';
      hasError = true;
    }

    if (!formFields.toDate.trim()) {
      newErrors.toDate = 'Enter To Date';
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;

    console.log('From Date:', formFields.fromDate);
    console.log('To Date:', formFields.toDate);

    setShowTable(true);
  };

  const handleExport = () => {
    console.log('Export clicked');
  };

  const downloadPDF = () => {
    // PDF download logic
  };

  return (
    <MainLayout pageName={"4"}>
      <div className="relative m-3 bg-white rounded-lg">
        <div className={mainTable.headerTitle}>
          <div className="my-2 mx-12 md:grid gap-4 mb-6 md:grid-cols-2 sm:col-span-1 lg:mx-0">
            Complaints and Issues
          </div>

          <div className={mainTable.grid3}>
            <InputText
              inputType="date"
              title="From Date"
              classStar="text-red-500"
              name="fromDate"
              disabled={false}
              content={formFields.fromDate}
              controlFunc={(e) =>
                setFormFields({ ...formFields, fromDate: e.target.value })
              }
              controlFuncBlur={handleBlur}
              errorMessage={errors.fromDate}
              inputClassName="w-full"
            />

            <InputText
              inputType="date"
              title="To Date"
              classStar="text-red-500"
              name="toDate"
              disabled={false}
              content={formFields.toDate}
              controlFunc={(e) =>
                setFormFields({ ...formFields, toDate: e.target.value })
              }
              controlFuncBlur={handleBlur}
              errorMessage={errors.toDate}
              inputClassName="w-full"
            />

            <div className="flex justify-start items-center mt-7 mb-6">
              <button
                type="button"
                onClick={GoButton}
                className={mainTable.addButton}
              >
                GO
              </button>
            </div>
          </div>
        </div>

        {showTable && (
          BindEnquirytobookingData.length > 0 ? (

            <ReportGridPage
              header={ComplaintsAndIssuesHeader}
              records={BindEnquirytobookingData}
              handleExport={handleExport}
              handlePDF={downloadPDF}
            // xScroll={"max-md:w-fit w-fit w-full"}
            />

          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          )
        )}
      </div>
    </MainLayout>
  );
};

export default ComplaintsAndIssues;